import * as React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { RenderField, Validators } from '../../Layout/Form/Fields/_Fields';
import { withTranslation  } from 'react-i18next';
import { compose } from 'redux';

const LoginForm = props => {
    const { errorStore, handleSubmit, pristine, submitting, t,invalid } = props;
    return (
        <form className="form" onSubmit={handleSubmit}>
            {errorStore.responseError.data && <p className="form_field--error">{t(`errors:${errorStore.responseError.data.errorSubcode}`)}</p>}
            <Field name="email" component={RenderField} type="text" placeholder={t('loginLabel')} label={t('loginLabel')} validate={[Validators.required, Validators.email]} />
            <Field name="password" component={RenderField} label={t('password')} type="password" placeholder={t('password')} validate={[Validators.required]} />
            <p>
                {t('forgotPassword')} <Link to="/password-reset">{t('resetPassword')}</Link>
            </p>
            <button disabled={invalid|| submitting || pristine} className="btn btn--blue" type="submit">
                {t('logIn')}
            </button>
        </form>
    );
};

function mapStateToProps(state: any) {
    return {
        viewManagementStore: state.viewManagementStore,
        userStore: state.userStore,
        errorStore: state.errorStore
    };
}


export default compose(
    connect(mapStateToProps),
    withTranslation (['forms', 'errors']),
    reduxForm({
        form: 'loginForm'
    })
)(LoginForm) as React.ComponentClass<any>



// WEBPACK FOOTER //
// ./src/components/UserSigning/Forms/_LoginForm.tsx